import log from "loglevel";
import React from "react";
import CallsCard from "./CallsCard";


const filterEarnings = (props) => {
  const { event: { year, quarter }, earnings } = props;
  if (!earnings || earnings.length === 0) {
    return undefined;
  }
  return earnings.filter((event) => event.year !== year || event.quarter !== quarter);
};

const MoreCalls = (props) => {

  const { isApproved, exchange, symbol, companyName, earnings } = props;
  log.debug("earnings:", earnings);
  const filteredEarnings = filterEarnings(props);

  if (!filteredEarnings || filteredEarnings.length === 0) {
    return (<></>);
  }

  return (
    <>
      <p className="lbl">More calls from {companyName}</p>
      <div className="call-block">
        { filteredEarnings?.map((event, i) =>
          <CallsCard key={i}
            isApproved={isApproved}
            exchange={exchange}
            symbol={symbol}
            event={event}
          />)
        }
      </div>
    </>
  );
};

export default MoreCalls;
